// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._109itzc0 {
  max-width: 17.5%;
}
.q0scmm3 ._109itzc0 {
  width: 23.5%;
  min-height: auto;
}
._109itzc1 {
  width: 82.5%;
}
.q0scmm3 ._109itzc1 {
  padding-left: var(--_18w76bwc);
  width: 76%;
}
._109itzc2:hover {
  text-decoration: underline;
}
._109itzc3 {
  padding: 16px 0;
}
.q0scmm3 ._109itzc3 {
  padding-left: 0;
}
._109itzc5 {
  color: black;
}
._109itzc6 {
  border: 2px solid var(--_18w76bw2p);
}
._109itzc7 {
  padding: 16px 0;
}
@media (min-width: 768px) {
  ._109itzc0 {
    max-width: var(--_18w76bw13);
    min-height: var(--_18w76bw13);
  }
  ._109itzc1 {
    width: calc(42.5% - 100px);
    flex-grow: 1;
    padding-left: var(--_18w76bwm);
  }
  ._109itzc3 {
    width: auto;
  }
  ._109itzc4 {
    min-width: 116px;
  }
  ._109itzc5 {
    min-width: 150px;
    text-align: right;
    width: 180px;
  }
  .q0scmm3 ._109itzc5 {
    min-width: auto;
    text-align: left;
    width: auto;
  }
  ._109itzc7 {
    min-width: 60px;
    width: auto;
    padding: 0 16px;
  }
  .q0scmm3 ._109itzc7 {
    min-width: auto;
    margin-top: var(--_18w76bwb);
    padding-right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,UAAU;AACZ;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,mCAAmC;AACrC;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,YAAY;IACZ,8BAA8B;EAChC;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;EACA;IACE,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;EAClB;AACF","sourcesContent":["._109itzc0 {\n  max-width: 17.5%;\n}\n.q0scmm3 ._109itzc0 {\n  width: 23.5%;\n  min-height: auto;\n}\n._109itzc1 {\n  width: 82.5%;\n}\n.q0scmm3 ._109itzc1 {\n  padding-left: var(--_18w76bwc);\n  width: 76%;\n}\n._109itzc2:hover {\n  text-decoration: underline;\n}\n._109itzc3 {\n  padding: 16px 0;\n}\n.q0scmm3 ._109itzc3 {\n  padding-left: 0;\n}\n._109itzc5 {\n  color: black;\n}\n._109itzc6 {\n  border: 2px solid var(--_18w76bw2p);\n}\n._109itzc7 {\n  padding: 16px 0;\n}\n@media (min-width: 768px) {\n  ._109itzc0 {\n    max-width: var(--_18w76bw13);\n    min-height: var(--_18w76bw13);\n  }\n  ._109itzc1 {\n    width: calc(42.5% - 100px);\n    flex-grow: 1;\n    padding-left: var(--_18w76bwm);\n  }\n  ._109itzc3 {\n    width: auto;\n  }\n  ._109itzc4 {\n    min-width: 116px;\n  }\n  ._109itzc5 {\n    min-width: 150px;\n    text-align: right;\n    width: 180px;\n  }\n  .q0scmm3 ._109itzc5 {\n    min-width: auto;\n    text-align: left;\n    width: auto;\n  }\n  ._109itzc7 {\n    min-width: 60px;\n    width: auto;\n    padding: 0 16px;\n  }\n  .q0scmm3 ._109itzc7 {\n    min-width: auto;\n    margin-top: var(--_18w76bwb);\n    padding-right: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
